module.exports = __webpack_public_path__ + "static/media/icon-household-full-disabled.2814c2b7.png";